import { Directive } from '@angular/core';

@Directive({
  selector: '[appMtboValidation]',
  standalone: false
})
export class MtboValidationDirective {

  constructor() { }

}
